import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import {NzUploadFile, UploadFilter } from 'ng-zorro-antd/upload';
import { Observable, Observer } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ConfigurationService } from '../../services/configuration.service';
import { RequesterService } from '../../services/requester.service';

@Component({
  selector: 'app-upload-box',
  templateUrl: './upload-box.component.html',
  styleUrls: ['./upload-box.component.scss'],
})
export class UploadBoxComponent implements OnInit {
  @Input() attachments: any[] = [];
  @Output() attachmentsChange: EventEmitter<any[]> = new EventEmitter<any[]>();
  @Input() deleteEnabled = false;
  configuration = ConfigurationService;
  mediaBaseUrl = this.configuration.apiBaseUrl + '/uploads/';
  fileList: any[] = [];
  uploading = false;
  fileListForDisplay: any[] = [];
  mediaUploadURL = environment.apiUrl + '/api/media';
  attachmentsLoading = false;
  customHeaders: any = {
    // Authorization: "Bearer " + localStorage.getItem("bearerToken"),
    Authorization: 'Bearer ' + RequesterService.getAuthToken(),
  };
  existingFiles: any[] = [];
  constructor(private msg: NzMessageService) {}

  filters: UploadFilter[] = [
    {
      name: 'type',
      fn: (fileList: NzUploadFile[]) => {
        // // tslint:disable-next-line:no-bitwise
        // const filterFiles = fileList.filter(
        //   (w) =>
        //     ~[
        //       'image/png',
        //       'image/jpg',
        //       'image/jpeg',
        //       'image/tiff',
        //       'application/pdf',
        //     ].indexOf(w.type)
        // );
        // if (filterFiles.length !== fileList.length) {
        //   this.msg.error(`Some Files are of Invalid type`);
        //   return filterFiles;
        // }
        return fileList;
      },
    },
    {
      name: 'async',
      fn: (fileList: NzUploadFile[]) => {
        return new Observable((observer: Observer<NzUploadFile[]>) => {
          // doing
          observer.next(fileList);
          observer.complete();
        });
      },
    },
  ];

  // tslint:disable-next-line:no-any
  handleChange(info: any): void {
    const fileList = info.fileList;
    this.fileList = [];
    // 2. read from response and show file link
    if (info.file.response) {
      info.file.url = info.file.response.url;
    }
    // 3. filter successfully uploaded files according to response from server
    // tslint:disable-next-line:no-any
    console.log([...fileList]);
    this.fileList = fileList.filter((item: any) => {
      if (item.response) {
        return item.response.success;
      }
      return true;
    });
    this.attachmentsLoading = fileList.some(
      (item: any) => !item.response && item.status !== 'error'
    );
    if (!this.attachmentsLoading) {
      this.attachments = [
        ...this.existingFiles,
        ...this.fileList.filter((x) => x.response).map((x) => x.response.data),
      ];
      this.attachmentsChange.emit(this.attachments);
    }
  }

  removeFile = (index: number): void => {
    this.attachments.splice(index, 1);
    this.attachmentsChange.emit(this.attachments);
  }

  ngOnInit() {
    this.existingFiles = [...this.attachments];
  }
}
